import DkRegulation from "./dk_regulation";
import {Check, TimeSpan} from "@sparkware/app-utils";


export default class MrgreenDenmarkRegulation extends DkRegulation {
    static CLASS = 'MrgreenDenmarkRegulation';

    getRealityCheckInterval() {
        if (this.serviceFactory.skinService().useControlCenterForReminderInterval()) {
            const accountData = this.serviceFactory.userService().getAccountData();
            if (accountData && !Check.isNullOrUndefined(accountData.RealityCheckDataIntervalInMins)) {
                return TimeSpan.fromMinutes(accountData.RealityCheckDataIntervalInMins);
            }
        }
        return super.getRealityCheckInterval();
    }

}
